import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getCustomerAddressListing = createAsyncThunk(
  "customerAddressList/getCustomerAddressListing",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/customerAddress/get_all_data`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const customerAddressSlice = createSlice({
  name: "customerAddressList",
  initialState: {
    loading: false,
    customerAddressListingData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerAddressListing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCustomerAddressListing.fulfilled, (state, action) => {
        state.loading = false;
        state.customerAddressListingData = action.payload;
      })
      .addCase(getCustomerAddressListing.rejected, (state, action) => {
        state.loading = false;
        state.customerAddressListingData = action.payload;
        state.error = action.payload;
      });
  },
});

export default customerAddressSlice.reducer;
